import styled from "styled-components"
import { device } from "breakpoints"

export const Container = styled.div`
  background: #F8F7F4;

`
